import { useEffect, useState } from "react";

const NAV_LINKS = [
  { label: "风向榜", href: "#trending" },
  { label: "反应分类", href: "#reactions" },
  { label: "深度洞察", href: "#analysis" },
  { label: "时间线", href: "#timeline" },
  { label: "粉圈词典", href: "#glossary" },
  { label: "常见问题", href: "#faq" },
  { label: "关于", href: "#about" },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 12);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const close = () => setOpen(false);

  return (
    <header
      className={`fixed inset-x-0 top-0 z-50 transition-colors duration-300 ${
        scrolled || open
          ? "bg-background-50/92 backdrop-blur-md border-b border-background-200"
          : "bg-transparent border-b border-transparent"
      }`}
    >
      <nav className="mx-auto flex h-16 md:h-[72px] max-w-[1280px] items-center justify-between px-4 md:px-6">
        <a href="#top" className="flex items-center gap-2.5" onClick={close}>
          <span className="relative flex h-9 w-9 items-center justify-center rounded-full bg-primary-500 text-background-50">
            <i className="ri-radar-line text-lg" aria-hidden="true"></i>
            <span className="absolute inset-0 rounded-full border border-primary-400 animate-radar-ping"></span>
          </span>
          <span className="text-foreground-950">
            <span className="block font-heading text-lg md:text-xl font-bold leading-none tracking-wide">
              星闻雷达
            </span>
            <span className="mt-1 block text-[10px] md:text-[11px] leading-none tracking-[0.3em] text-foreground-600">
              塌房舆论观察
            </span>
          </span>
        </a>

        <div className="hidden items-center gap-1 lg:flex">
          {NAV_LINKS.map((link) => (
            <a
              key={link.href}
              href={link.href}
              className="whitespace-nowrap rounded-md px-3 py-2 text-sm text-foreground-700 transition-colors hover:bg-background-100 hover:text-primary-700"
            >
              {link.label}
            </a>
          ))}
        </div>

        <div className="flex items-center gap-2">
          <a
            href="#newsletter"
            className="hidden whitespace-nowrap items-center gap-1.5 rounded-md bg-primary-500 px-4 py-2 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600 md:inline-flex"
          >
            <i className="ri-mail-send-line text-base" aria-hidden="true"></i>
            订阅周报
          </a>
          <button
            type="button"
            aria-label="打开菜单"
            aria-expanded={open}
            onClick={() => setOpen((v) => !v)}
            className="flex h-10 w-10 items-center justify-center rounded-md text-foreground-800 hover:bg-background-100 lg:hidden"
          >
            <i className={open ? "ri-close-line text-2xl" : "ri-menu-line text-2xl"} aria-hidden="true"></i>
          </button>
        </div>
      </nav>

      {open && (
        <div className="border-t border-background-200 bg-background-50/98 lg:hidden">
          <div className="mx-auto max-w-[1280px] px-4 py-3 md:px-6">
            <div className="flex flex-col">
              {NAV_LINKS.map((link) => (
                <a
                  key={link.href}
                  href={link.href}
                  onClick={close}
                  className="rounded-md px-3 py-3 text-[15px] text-foreground-800 transition-colors hover:bg-background-100 hover:text-primary-700"
                >
                  {link.label}
                </a>
              ))}
              <a
                href="#newsletter"
                onClick={close}
                className="mt-2 inline-flex items-center justify-center gap-1.5 whitespace-nowrap rounded-md bg-primary-500 px-4 py-3 text-sm font-medium text-background-50 hover:bg-primary-600"
              >
                <i className="ri-mail-send-line text-base" aria-hidden="true"></i>
                订阅风向周报
              </a>
            </div>
          </div>
        </div>
      )}
    </header>
  );
}